import { useMediaQuery } from "react-responsive";
import { useContext } from "react";
import { dataContext } from "../../context/context";
import HeaderDesktop from './headerDesktop';
import HeaderMobile from './headerMobile';

const Header = () => {

    const isMobile = useMediaQuery({ query: "(max-width: 1000px)" });
    const { data, loading, error  } = useContext(dataContext);

    if (loading) return (

        <></>

    );

    else if (!data || error) return (

        <></>


    );

    else {

        if (isMobile) {
            return (
                <HeaderMobile/>
            );
        } else return (
            <HeaderDesktop/>
        )
    }
}

export default Header